import { useState } from "react";
import Image from "next/image";
import { Stack } from "@mui/material";
import ShortLinkInput from "../../ShortLinkInput";

import BarcodeBTC from "../../../../../../public/assets/images/coins/btc.jpeg";
import BarcodeETH from "../../../../../../public/assets/images/coins/eth.jpeg";
import BarcodeTET from "../../../../../../public/assets/images/coins/tet.jpeg";
import tether from "../../../../../../public/assets/images/paymentMethods/Thether.svg";
import bitcoin from "../../../../../../public/assets/images/paymentMethods/Bitcoin.svg";
import bnb from "../../../../../../public/assets/images/paymentMethods/Bnb.svg";
import { useTheme } from "@material-ui/core/styles";
import { Typography, useMediaQuery } from "@material-ui/core";

const WalletComponent = () => {
  const ttLink = "TPubV48adkvk1ts6D771fRaTi4Zo6HrQrD";
  const btcLink = "bc1qjyn43j4gawhg52s7dry0r9h3fj8na2eyx8t5wm";
  const bnbLink = "0xC8ED4381e2bD516Db97cF8BaEC8C0E07918bc127";

  const ArrayWallet = [
    {
      icon: tether,
      img: BarcodeTET,
      link: ttLink,
      text: "TETHER TRC20",
      color: "#039393",
    },
    {
      icon: bitcoin,
      img: BarcodeBTC,
      link: btcLink,
      text: "BITCOIN",
      color: "#F7931A",
    },
    {
      icon: bnb,
      img: BarcodeETH,
      link: bnbLink,
      text: "BNB",
      color: "#F3BA2F",
    },
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      alignItems={"center"}
      justifyContent={"space-around"}
      sx={{
        width: "100%",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        width={isMobile ? "100%" : "30%"}
        sx={{
          cursor: "pointer",
        }}
      >
        {ArrayWallet.map((item, index) => (
          <Stack
            key={index}
            onClick={() => handleClick(index)}
            sx={{
              backgroundColor: selectedIndex === index ? "#FFFFFF" : "",
              boxShadow:
                selectedIndex === index
                  ? "0px 0px 14px 2px rgba(0,0,0,0.1)"
                  : "",
              width: "157px",
              height: "125px",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              borderRadius: 5,
            }}
          >
            <Image src={item.icon} alt="icon" width={90} height={90} />
            <Typography
              style={{
                color: item.color,
                fontFamily: "vazir",
                marginTop: "5px",
              }}
            >
              {item.text}
            </Typography>
          </Stack>
        ))}
      </Stack>
      {ArrayWallet[selectedIndex] && (
        <Stack
          direction={isMobile ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          mt={2}
          style={{ width: isMobile ? "100%" : "54%" }}
        >
          <Image
            src={ArrayWallet[selectedIndex].img}
            alt="barcode"
            width={130}
            height={130}
          />
          <div
            style={{
              marginTop: isMobile ? "15px" : 0,
              width: isMobile ? "100%" : "76%",

              marginRight: isMobile ? 0 : 10,
            }}
          >
            <ShortLinkInput link={ArrayWallet[selectedIndex].link} />
          </div>
        </Stack>
      )}
    </Stack>
  );
};

export default WalletComponent;
